export const photoURL = ((id: string) => `https://tondtond.com/cdn-cgi/imagedelivery/9PzV3JPEUrshMJ9ZabWUKw/${id}/public`)